export default __webpack_public_path__ + "static/media/Union.4563677b.svg";